import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Sentinel value for the "Other…" choice in the make/model selects. The real
 * free-text value lives in the companion makeOther/modelOther control and is
 * merged in by vehicleFormValue().
 */
export const OTHER_OPTION = '__other__';

/**
 * Group-level check: when "Other…" is selected, the companion free-text
 * control must be filled in before the form is valid.
 */
export const otherTextRequiredValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const errors: ValidationErrors = {};
  if (group.get('make')?.value === OTHER_OPTION && !(group.get('makeOther')?.value ?? '').trim()) {
    errors['makeOtherRequired'] = true;
  }
  if (group.get('model')?.value === OTHER_OPTION && !(group.get('modelOther')?.value ?? '').trim()) {
    errors['modelOtherRequired'] = true;
  }
  return Object.keys(errors).length ? errors : null;
};
